import {
  QUANLYNAPCUOC_COUNT_ASSIGN_SUCCESS,
  QUANLYNAPCUOC_HISTORY_LIST_SUCCESS,
  QUANLYNAPCUOC_IMPORT_SUCCESS,
  QUANLYNAPCUOC_LIST_SUCCESS,
  QUANLYNAPCUOC_NEW_CARE_SUCCESS,
  QUANLYNAPCUOC_ONE_SUCCESS,
  QUANLYNAPCUOCCHITIET_ONE_SUCCESS,
  QUANLYNAPCUOC_UPDATE_FILTER,
  QUANLYNAPCUOCCHITIET_LIST_SUCCESS,
  QUANLYNAPCUOC_THONG_KE_SUCCESS,
  QUANLYNAPCUOC_DON_CHO_HE_THONG_SUCCESS,
  QUANLYNAPCUOC_UPDATE_FILTER_DON_CHO_HE_THONG,
} from 'src/actions/quanlynapcuoc.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

import dayjs from 'dayjs';

const today = new Date();

const initState = {
  filter: {
    message: '',
    startDate: dayjs(new Date(today.getFullYear(), today.getMonth(), 1)),
    endDate: dayjs(today),
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  donchohethongfilter: {
    donchohethongpage: 0,
    donchohethonglimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  thongkeitems: [],
  donchohethongitems: [],
  donchohethongtotal: 0,
  total: 0,
  quanlynapcuocchitiet_items: [],
  quanlynapcuocchitiet_total: 0,
  temp: [],
  selected: undefined,
  selectedChiTiet: undefined,
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0
}

const quanlynapcuocReducer = (state = initState, action) => {
  switch (action.type) {
    case QUANLYNAPCUOC_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case QUANLYNAPCUOC_UPDATE_FILTER_DON_CHO_HE_THONG:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.donchohethongfilter !== 'undefined' && state.donchohethongfilter) {
        if (action.data.donchohethongpage == 'no_update' && typeof state.donchohethongfilter.donchohethongpage !== 'undefined') action.data.donchohethongpage = state.donchohethongfilter.donchohethongpage;
        if (action.data.donchohethonglimit == 'no_update' && typeof state.donchohethongfilter.donchohethonglimit !== 'undefined') action.data.donchohethonglimit = state.donchohethongfilter.donchohethonglimit;
      }
      return {
        ...state,
        donchohethongfilter: action.data,
      }
    }
    case QUANLYNAPCUOCCHITIET_LIST_SUCCESS: {
      return {
        ...state,
        quanlynapcuocchitiet_items: action.data.items,
        quanlynapcuocchitiet_total: action.data.total,
        quanlynapcuocchitiet_tong_can_nap: action.data.tong_can_nap,
        quanlynapcuocchitiet_tong_da_nap: action.data.tong_da_nap,
        quanlynapcuocchitiet_tong_huy_nap: action.data.tong_huy_nap,
        quanlynapcuocchitiet_tong_that_bai: action.data.tong_that_bai,
        quanlynapcuocchitiet_tong_ton_nap: action.data.tong_ton_nap,
      }
    }
    case QUANLYNAPCUOC_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
        tong_can_nap: action.data.tong_can_nap,
        tong_da_nap: action.data.tong_da_nap,
        tong_huy_nap: action.data.tong_huy_nap,
        tong_that_bai: action.data.tong_that_bai,
        tong_ton_nap: action.data.tong_ton_nap,
      }
    }
    case QUANLYNAPCUOC_THONG_KE_SUCCESS: {
      return {
        ...state,
        thongkeitems: action.data.items,
      }
    }
    case QUANLYNAPCUOC_DON_CHO_HE_THONG_SUCCESS: {
      return {
        ...state,
        donchohethongitems: action.data.items,
        donchohethongtotal: action.data.total,
        donchohethong_tong_can_nap: action.data.tong_can_nap,
        donchohethong_tong_da_nap: action.data.tong_da_nap,
        donchohethong_tong_huy_nap: action.data.tong_huy_nap,
        donchohethong_tong_that_bai: action.data.tong_that_bai,
        donchohethong_tong_ton_nap: action.data.tong_ton_nap,
      }
    }
    case QUANLYNAPCUOC_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case QUANLYNAPCUOCCHITIET_ONE_SUCCESS: {
      return {
        ...state,
        selectedChiTiet: action.data
      }
    }
    case QUANLYNAPCUOC_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case QUANLYNAPCUOC_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case QUANLYNAPCUOC_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case QUANLYNAPCUOC_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    default: {
      return state;
    }
  }
}
export default quanlynapcuocReducer